<script setup>
import { computed } from 'vue'

const props = defineProps({
  variant: { type: String, default: 'primary' },
  size: { type: String, default: 'md' },
  type: { type: String, default: 'button' },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  block: { type: Boolean, default: false }
})

const classes = computed(() => {
  const variants = {
    primary: 'bg-slate-950 text-white hover:bg-slate-800 focus-visible:ring-slate-300',
    brand: 'bg-brand-500 text-white hover:bg-brand-600 focus-visible:ring-brand-200',
    secondary: 'border border-app-border bg-white text-app-text hover:bg-slate-50 focus-visible:ring-slate-200',
    ghost: 'text-app-muted hover:bg-slate-100 hover:text-app-text focus-visible:ring-slate-200',
    danger: 'border border-danger-200 bg-danger-50 text-danger-700 hover:bg-red-100 focus-visible:ring-danger-200'
  }
  const sizes = {
    sm: 'min-h-9 rounded-lg px-3 py-2 text-xs',
    md: 'min-h-11 rounded-app-control px-4 py-2.5 text-sm',
    lg: 'min-h-12 rounded-app-control px-5 py-3 text-sm'
  }
  return [variants[props.variant] || variants.primary, sizes[props.size] || sizes.md, props.block ? 'w-full' : '']
})
</script>

<template>
  <button
    :type="type"
    :disabled="disabled || loading"
    class="inline-flex items-center justify-center gap-2 font-black shadow-sm transition focus-visible:outline-none focus-visible:ring-4 disabled:cursor-not-allowed disabled:opacity-55"
    :class="classes"
  >
    <svg v-if="loading" class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="3" opacity=".25"/><path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>
    <slot />
  </button>
</template>
